export default __webpack_public_path__ + "static/media/tick-tac-toe.d3d9a6aa.png";